<app-tab-toolbar [tabId]="'employees'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCarriedForward" [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement" [showKeywordsToggle]="true" [keywordsVisible]="showKeywords" (keywordsVisibleChange)="showKeywords = $event" (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>{{ isCarriedForward ? 'info' : 'warning' }}</mat-icon>
      @if (isCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="employees-content" [formGroup]="form" [appReadOnlyTab]="'employees'">

  <div class="main-layout">
  <div class="left-column">
  <div class="top-tables">

    <!-- Hires & Turnovers -->
    <div class="ht-grid">
      <!-- Title header -->
      <div class="ht-label"></div>
      <div class="ht-title-header" style="grid-column: span 9">Hires & Turnovers</div>

      <!-- Group headers -->
      <div class="ht-label"></div>
      <div class="ht-group-header" style="grid-column: span 3">Employees</div>
      <div class="ht-group-header" style="grid-column: span 2">New employee hires</div>
      <div class="ht-group-header" style="grid-column: span 2">Employee turnover</div>
      <div class="ht-group-header" style="grid-column: span 2">Voluntary turnover</div>

      <!-- Sub-headers -->
      <div class="ht-label ht-row-header">Employees</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header"></div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>

      <!-- Total No -->
      <div class="ht-label">Total No</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="total" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.total) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="totalPct" class="ht-input ht-input-calculated" readonly>
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.totalPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <select formControlName="totalType" class="ht-select">
          <option [ngValue]="null"></option>
          @for (t of totalTypes; track t.value) {
            <option [ngValue]="t.value">{{ t.label }}</option>
          }
        </select>
        @if (otherMeasurement) {<span class="ht-other">{{ getTotalTypeLabel(otherData?.totalType) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newEmployeeHires" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newEmployeeHires) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newEmployeeHiresPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newEmployeeHiresPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeeTurnover" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeeTurnover) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeeTurnoverPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeeTurnoverPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="voluntaryTurnover" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.voluntaryTurnover) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="voluntaryTurnoverPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.voluntaryTurnoverPct, 2) }}</span>}
      </div>

      <!-- Permanent -->
      <div class="ht-label">Permanent</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="permanent" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.permanent) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="permanentPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.permanentPct, 2) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>

      <!-- Temporary -->
      <div class="ht-label">Temporary</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="temporary" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.temporary) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="temporaryPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.temporaryPct, 2) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>

      <!-- Full Time -->
      <div class="ht-label">Full Time</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="fullTime" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.fullTime) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="fullTimePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.fullTimePct, 2) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>

      <!-- Part-Time -->
      <div class="ht-label">Part-Time</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="partTime" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.partTime) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="partTimePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.partTimePct, 2) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>

      <!-- Contractors -->
      <div class="ht-label ht-row-header">Contractors</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="contractors" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractors) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
    </div>

    <!-- Health & Safety -->
    <div class="hs-grid">
      <!-- Title header -->
      <div class="ht-label"></div>
      <div class="ht-title-header" style="grid-column: span 7">Health & Safety</div>

      <!-- Column headers -->
      <div class="ht-label"></div>
      <div class="ht-group-header">Injury Rate</div>
      <div class="ht-group-header">Accidents</div>
      <div class="ht-group-header">Fatalities</div>
      <div class="ht-group-header">LTIR</div>
      <div class="ht-group-header">TRIR</div>
      <div class="ht-group-header">Lost Working Days</div>
      <div class="ht-group-header">Absentee Rate</div>

      <!-- Sub-headers -->
      <div class="ht-label"></div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div>
      <div class="ht-col-header">%</div>

      <!-- Employees row -->
      <div class="ht-label"></div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="injuryRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.injuryRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="accidents" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.accidents) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="fatalities" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.fatalities) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="lostTimeIncidentRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.lostTimeIncidentRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="totalRecordableIncidentRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.totalRecordableIncidentRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="lostWorkingDays" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.lostWorkingDays) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="absenteeRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.absenteeRate, 2) }}</span>}
      </div>

      <!-- Permanent -->
      <div class="ht-label"></div>
      <div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div>

      <!-- Temporary -->
      <div class="ht-label"></div>
      <div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div>

      <!-- Full Time -->
      <div class="ht-label"></div>
      <div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div>

      <!-- Part-Time -->
      <div class="ht-label"></div>
      <div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div><div class="ht-cell-empty"></div>

      <!-- Contractors row -->
      <div class="ht-label"></div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="contractorsInjuryRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsInjuryRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="contractorsAccidents" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsAccidents) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="contractorsFatalities" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsFatalities) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="contractorsLostTimeIncidentRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsLostTimeIncidentRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="contractorsTotalRecordableIncidentRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsTotalRecordableIncidentRate, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="contractorsLostWorkingDays" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsLostWorkingDays) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="contractorsAbsenteeRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.contractorsAbsenteeRate, 2) }}</span>}
      </div>

      <!-- Total row -->
      <div class="ht-label ht-row-header">TOTAL</div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="totalAccidents" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.totalAccidents) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="totalFatalities" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.totalFatalities) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell-empty"></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="totalLostWorkingDays" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.totalLostWorkingDays) }}</span>}
      </div>
      <div class="ht-cell-empty"></div>
    </div>

  </div>

  @if (showKeywords) {
    <div class="keywords-row" formGroupName="keywords">
      <div class="keywords-section">
        <div class="section-header">
          <span>Keywords</span>
        </div>
        <div class="keywords-fields">
          <app-keyword-input name="hires" label="Hires & Turnovers" />
        </div>
      </div>
      <div class="keywords-section">
        <div class="section-header">
          <span>Keywords</span>
        </div>
        <div class="keywords-fields">
          <app-keyword-input name="health" label="Health & Safety" />
        </div>
      </div>
    </div>
  }

  <!-- Demographics -->
  <div class="demo-section">
    <div class="demo-grid">
      <!-- Title header -->
      <div class="ht-label"></div>
      <div style="grid-column: span 5"></div>
      <div></div>
      <div class="ht-title-header" style="grid-column: span 6">Composition of governance bodies (%)</div>

      <!-- Group headers -->
      <div class="ht-label"></div>
      <div class="ht-group-header" style="grid-column: span 2">New Employee hires</div>
      <div></div>
      <div class="ht-group-header" style="grid-column: span 2">Employee turnover</div>
      <div></div>
      <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">Board of Directors</div>
      <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">Leadership Team</div>
      <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">Employees</div>

      <!-- Column sub-headers -->
      <div class="ht-label"></div>
      <div class="ht-col-header">Number</div><div class="ht-col-header">%</div>
      <div></div>
      <div class="ht-col-header">Number</div><div class="ht-col-header">%</div>
      <div></div>
      <div class="ht-col-header">Number</div><div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div><div class="ht-col-header">%</div>
      <div class="ht-col-header">Number</div><div class="ht-col-header">%</div>

      <!-- ========== BY GENDER ========== -->
      <div class="demo-section-header">By Gender</div>

      <!-- Male -->
      <div class="ht-label">Male</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresMale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresMale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresMalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresMalePct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverMale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverMale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverMalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverMalePct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardMale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardMale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardMalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardMalePct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipMale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipMale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipMalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipMalePct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesMale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesMale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesMalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesMalePct, 2) }}</span>}
      </div>

      <!-- Female -->
      <div class="ht-label">Female</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresFemale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresFemale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresFemalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresFemalePct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverFemale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverFemale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverFemalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverFemalePct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardFemale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardFemale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardFemalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardFemalePct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipFemale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipFemale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipFemalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipFemalePct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesFemale" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesFemale) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesFemalePct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesFemalePct, 2) }}</span>}
      </div>

      <!-- LGBT -->
      <div class="ht-label">LGBT</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresLgbt" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresLgbt) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresLgbtPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresLgbtPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverLgbt" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverLgbt) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverLgbtPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverLgbtPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardLgbt" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardLgbt) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardLgbtPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardLgbtPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipLgbt" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipLgbt) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipLgbtPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipLgbtPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesLgbt" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesLgbt) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesLgbtPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesLgbtPct, 2) }}</span>}
      </div>

      <!-- Sum of % — By Gender -->
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('newHires', demoPctSuffixes.gender))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('turnover', demoPctSuffixes.gender))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('board', demoPctSuffixes.gender))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('leadership', demoPctSuffixes.gender))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('employees', demoPctSuffixes.gender))">
      </div>

      <!-- ========== BY AGE GROUP ========== -->
      <div class="demo-section-header">By Age Group</div>

      <!-- Under 30 years old -->
      <div class="ht-label">Under 30 years old</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresUnderThirty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresUnderThirty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresUnderThirtyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresUnderThirtyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverUnderThirty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverUnderThirty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverUnderThirtyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverUnderThirtyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardUnderThirty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardUnderThirty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardUnderThirtyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardUnderThirtyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipUnderThirty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipUnderThirty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipUnderThirtyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipUnderThirtyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesUnderThirty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesUnderThirty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesUnderThirtyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesUnderThirtyPct, 2) }}</span>}
      </div>

      <!-- 30-50 years old -->
      <div class="ht-label">30-50 years old</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresOverThirtyUnderFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOverThirtyUnderFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresOverThirtyUnderFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOverThirtyUnderFiftyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverOverThirtyUnderFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOverThirtyUnderFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverOverThirtyUnderFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOverThirtyUnderFiftyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardOverThirtyUnderFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOverThirtyUnderFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardOverThirtyUnderFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOverThirtyUnderFiftyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipOverThirtyUnderFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOverThirtyUnderFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipOverThirtyUnderFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOverThirtyUnderFiftyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesOverThirtyUnderFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOverThirtyUnderFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesOverThirtyUnderFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOverThirtyUnderFiftyPct, 2) }}</span>}
      </div>

      <!-- Over 50 years old -->
      <div class="ht-label">Over 50 years old</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresOverFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOverFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresOverFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOverFiftyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverOverFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOverFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverOverFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOverFiftyPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardOverFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOverFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardOverFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOverFiftyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipOverFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOverFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipOverFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOverFiftyPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesOverFifty" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOverFifty) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesOverFiftyPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOverFiftyPct, 2) }}</span>}
      </div>

      <!-- Non-classified -->
      <div class="ht-label">Non-classified</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresNonClassified" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresNonClassified) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresNonClassifiedPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresNonClassifiedPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverNonClassified" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverNonClassified) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverNonClassifiedPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverNonClassifiedPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardNonClassified" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardNonClassified) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardNonClassifiedPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardNonClassifiedPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipNonClassified" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipNonClassified) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipNonClassifiedPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipNonClassifiedPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesNonClassified" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesNonClassified) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesNonClassifiedPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesNonClassifiedPct, 2) }}</span>}
      </div>

      <!-- Sum of % — By Age Group -->
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('newHires', demoPctSuffixes.age))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('turnover', demoPctSuffixes.age))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('board', demoPctSuffixes.age))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('leadership', demoPctSuffixes.age))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('employees', demoPctSuffixes.age))">
      </div>

      <!-- ========== BY REGION ========== -->
      <div class="demo-section-header">By region</div>

      <!-- AMER -->
      <div class="ht-label">AMER</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresAmerica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAmerica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresAmericaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAmericaPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverAmerica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAmerica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverAmericaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAmericaPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardAmerica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAmerica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardAmericaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAmericaPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipAmerica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAmerica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipAmericaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAmericaPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesAmerica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAmerica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesAmericaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAmericaPct, 2) }}</span>}
      </div>

      <!-- APAC -->
      <div class="ht-label">APAC</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresAsiaPacific" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAsiaPacific) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresAsiaPacificPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAsiaPacificPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverAsiaPacific" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAsiaPacific) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverAsiaPacificPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAsiaPacificPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardAsiaPacific" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAsiaPacific) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardAsiaPacificPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAsiaPacificPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipAsiaPacific" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAsiaPacific) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipAsiaPacificPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAsiaPacificPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesAsiaPacific" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAsiaPacific) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesAsiaPacificPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAsiaPacificPct, 2) }}</span>}
      </div>

      <!-- EMEA -->
      <div class="ht-label">EMEA</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresEuropeAfrica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresEuropeAfrica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresEuropeAfricaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresEuropeAfricaPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverEuropeAfrica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverEuropeAfrica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverEuropeAfricaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverEuropeAfricaPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardEuropeAfrica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardEuropeAfrica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardEuropeAfricaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardEuropeAfricaPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipEuropeAfrica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipEuropeAfrica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipEuropeAfricaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipEuropeAfricaPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesEuropeAfrica" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesEuropeAfrica) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesEuropeAfricaPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesEuropeAfricaPct, 2) }}</span>}
      </div>

      <!-- OTHER -->
      <div class="ht-label">OTHER</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresOtherRegion" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOtherRegion) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresOtherRegionPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOtherRegionPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverOtherRegion" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOtherRegion) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverOtherRegionPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOtherRegionPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardOtherRegion" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOtherRegion) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardOtherRegionPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOtherRegionPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipOtherRegion" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOtherRegion) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipOtherRegionPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOtherRegionPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesOtherRegion" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOtherRegion) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesOtherRegionPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOtherRegionPct, 2) }}</span>}
      </div>

      <!-- Sum of % — By Region -->
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('newHires', demoPctSuffixes.region))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('turnover', demoPctSuffixes.region))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('board', demoPctSuffixes.region))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('leadership', demoPctSuffixes.region))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('employees', demoPctSuffixes.region))">
      </div>

      <!-- ========== BY MINORITY ========== -->
      <div class="demo-section-header">By minority</div>

      <!-- White/Caucasian -->
      <div class="ht-label">White/Caucasian</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresWhites" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresWhites) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresWhitesPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresWhitesPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverWhites" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverWhites) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverWhitesPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverWhitesPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardWhites" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardWhites) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardWhitesPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardWhitesPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipWhites" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipWhites) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipWhitesPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipWhitesPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesWhites" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesWhites) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesWhitesPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesWhitesPct, 2) }}</span>}
      </div>

      <!-- Blacks/African American -->
      <div class="ht-label">Blacks/African American</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresBlacks" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresBlacks) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresBlacksPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresBlacksPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverBlacks" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverBlacks) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverBlacksPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverBlacksPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardBlacks" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardBlacks) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardBlacksPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardBlacksPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipBlacks" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipBlacks) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipBlacksPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipBlacksPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesBlacks" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesBlacks) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesBlacksPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesBlacksPct, 2) }}</span>}
      </div>

      <!-- Asian/Pacific Islanders -->
      <div class="ht-label">Asian/Pacific Islanders</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresAsian" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAsian) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresAsianPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresAsianPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverAsian" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAsian) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverAsianPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverAsianPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardAsian" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAsian) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardAsianPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardAsianPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipAsian" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAsian) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipAsianPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipAsianPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesAsian" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAsian) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesAsianPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesAsianPct, 2) }}</span>}
      </div>

      <!-- Hispanic/Latinos -->
      <div class="ht-label">Hispanic/Latinos</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresHispanic" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresHispanic) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresHispanicPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresHispanicPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverHispanic" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverHispanic) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverHispanicPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverHispanicPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardHispanic" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardHispanic) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardHispanicPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardHispanicPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipHispanic" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipHispanic) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipHispanicPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipHispanicPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesHispanic" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesHispanic) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesHispanicPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesHispanicPct, 2) }}</span>}
      </div>

      <!-- Others -->
      <div class="ht-label">Others</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="newHiresOtherMinority" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOtherMinority) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="newHiresOtherMinorityPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.newHiresOtherMinorityPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="turnoverOtherMinority" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOtherMinority) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="turnoverOtherMinorityPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.turnoverOtherMinorityPct, 2) }}</span>}
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="boardOtherMinority" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOtherMinority) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="boardOtherMinorityPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.boardOtherMinorityPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipOtherMinority" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOtherMinority) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="leadershipOtherMinorityPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipOtherMinorityPct, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="employeesOtherMinority" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOtherMinority) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="employeesOtherMinorityPct" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeesOtherMinorityPct, 2) }}</span>}
      </div>

      <!-- Sum of % — By Minority -->
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('newHires', demoPctSuffixes.minority))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('turnover', demoPctSuffixes.minority))">
      </div>
      <div></div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('board', demoPctSuffixes.minority))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('leadership', demoPctSuffixes.minority))">
      </div>
      <div></div>
      <div class="ht-cell">
        <input type="text" class="ht-input ht-input-calculated" disabled [value]="formatPct(sumDemoPct('employees', demoPctSuffixes.minority))">
      </div>
    </div>
  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>
      @if (otherMeasurement && otherData?.comments) {
        <div class="comparison-hint">{{ otherData!.comments }}</div>
      }
    </div>
  </section>
  </div>

  <div class="right-column">
  <!-- Employees Summary -->
  <div class="emp-section">
    <div class="emp-grid">
      <!-- Title header -->
      <div class="ht-title-header" style="grid-column: span 3">Employees</div>

      <!-- Average Age -->
      <div class="ht-label">Average Age</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="averageAge" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.averageAge, 2) }}</span>}
      </div>

      <!-- Leadership Team (Total) -->
      <div class="ht-label">Leadership Team (Total)</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="leadershipTotal" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.leadershipTotal) }}</span>}
      </div>

      <!-- Disabled Employees -->
      <div class="ht-label">Disabled Employees</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="disabledEmployees" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.disabledEmployees) }}</span>}
      </div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="disabledEmployeesPct" class="ht-input" placeholder="%">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.disabledEmployeesPct, 2) }}</span>}
      </div>

      <!-- Gender Pay Gap -->
      <div class="ht-label">Gender Pay Gap</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [max]="100" [decimals]="2" formControlName="genderPayGap" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.genderPayGap, 2) }}</span>}
      </div>

      <!-- Average Male Salary -->
      <div class="ht-label">Average Male Salary</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="averageMaleSalary" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.averageMaleSalary) }}</span>}
      </div>
      <div class="ht-cell">
        <select formControlName="averageMaleSalaryCurrencyId" class="ht-select">
          <option value=""></option>
          @for (c of currencies; track c.id) {
            <option [value]="c.id">{{ c.name }}</option>
          }
        </select>
        @if (otherMeasurement) {<span class="ht-other">{{ getOtherCurrencyName(otherData?.averageMaleSalaryCurrencyId) }}</span>}
      </div>

      <!-- Average Female Salary -->
      <div class="ht-label">Average Female Salary</div>
      <div class="ht-cell">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="averageFemaleSalary" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.averageFemaleSalary) }}</span>}
      </div>
      <div class="ht-cell">
        <select formControlName="averageFemaleSalaryCurrencyId" class="ht-select">
          <option value=""></option>
          @for (c of currencies; track c.id) {
            <option [value]="c.id">{{ c.name }}</option>
          }
        </select>
        @if (otherMeasurement) {<span class="ht-other">{{ getOtherCurrencyName(otherData?.averageFemaleSalaryCurrencyId) }}</span>}
      </div>
    </div>

    @if (showKeywords) {
      <div class="keywords-section" formGroupName="keywords">
        <div class="section-header"><span>Keywords</span></div>
        <div class="keywords-fields keywords-fields--stacked">
          <app-keyword-input name="averageAge" label="Average Age" />
          <app-keyword-input name="leadership" label="Leadership Team (Total)" />
          <app-keyword-input name="disabled" label="Disabled Employees" />
          <app-keyword-input name="genderGap" label="Gender Pay Gap" />
        </div>
      </div>
    }
  </div>

  <!-- Parental Leave -->
  <div class="emp-section">
    <div class="emp-grid">
      <!-- Title header -->
      <div class="ht-title-header" style="grid-column: span 3">Parental Leave</div>

      <!-- Group header -->
      <div class="ht-group-header" style="grid-column: span 3">Employees</div>

      <!-- Entitled to P.L. -->
      <div class="ht-label">Entitled to P.L.</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="entitledToParentalLeave" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.entitledToParentalLeave) }}</span>}
      </div>

      <!-- Took P.L. -->
      <div class="ht-label">Took P.L.</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="tookToParentalLeave" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.tookToParentalLeave) }}</span>}
      </div>

      <!-- Returned to from P.L. -->
      <div class="ht-label">Returned to from P.L.</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="returnedFromParentalLeave" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.returnedFromParentalLeave) }}</span>}
      </div>
    </div>

    @if (showKeywords) {
      <div class="keywords-section" formGroupName="keywords">
        <div class="section-header"><span>Keywords</span></div>
        <div class="keywords-fields"><app-keyword-input name="parentalLeave" label="Parental Leave" /></div>
      </div>
    }
  </div>

  <!-- Training & Development -->
  <div class="emp-section">
    <div class="emp-grid">
      <!-- Title header -->
      <div class="ht-title-header" style="grid-column: span 3">Training & Development</div>

      <!-- Training Costs -->
      <div class="ht-label">Training Costs</div>
      <div class="ht-cell">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="trainingCosts" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.trainingCosts, 2) }}</span>}
      </div>
      <div class="ht-cell">
        <select formControlName="trainingCostsCurrencyId" class="ht-select">
          <option value=""></option>
          @for (c of currencies; track c.id) {
            <option [value]="c.id">{{ c.name }}</option>
          }
        </select>
        @if (otherMeasurement) {<span class="ht-other">{{ getOtherCurrencyName(otherData?.trainingCostsCurrencyId) }}</span>}
      </div>

      <!-- Working Hours -->
      <div class="ht-label">Working Hours</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="workingHours" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.workingHours, 2) }}</span>}
      </div>

      <!-- Employee Health Training Hours -->
      <div class="ht-label">Health Training Hours</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="employeeHealthTrainingHours" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.employeeHealthTrainingHours, 2) }}</span>}
      </div>

      <!-- Training Employees -->
      <div class="ht-label">Training Employees</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="numeric" appNumberFormat formControlName="trainingEmployees" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.trainingEmployees) }}</span>}
      </div>

      <!-- Training Hours Per Employee -->
      <div class="ht-label">Training Hrs/Employee</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [decimals]="2" formControlName="trainingHoursPerEmployee" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.trainingHoursPerEmployee, 2) }}</span>}
      </div>

      <!-- Trade Union Representation Rate -->
      <div class="ht-label">Trade Union Rep. Rate</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="tradeUnionRepresentationRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.tradeUnionRepresentationRate, 2) }}</span>}
      </div>

      <!-- Collective Agreement Rate -->
      <div class="ht-label">Collective Agr. Rate</div>
      <div class="ht-cell" style="grid-column: span 2">
        <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="collectiveAgreementRate" class="ht-input">
        @if (otherMeasurement) {<span class="ht-other">{{ formatNumber(otherData?.collectiveAgreementRate, 2) }}</span>}
      </div>
    </div>

    @if (showKeywords) {
      <div class="keywords-section" formGroupName="keywords">
        <div class="section-header"><span>Keywords</span></div>
        <div class="keywords-fields keywords-fields--stacked">
          <app-keyword-input name="training" label="Training & Development" />
          <app-keyword-input name="tradeUnion" label="Trade Union" />
          <app-keyword-input name="collective" label="Collective Agreement" />
        </div>
      </div>
    }
  </div>

  </div>
  </div>

</div>

<ngx-spinner name="primary" type="ball-spin-clockwise" [fullScreen]="false" size="medium" />
